module.exports = __webpack_public_path__ + "static/media/dark-modulo-gestao-servico.7387b791.svg";